import { useState, useEffect } from 'react';

function useDoubleSwitchDelay(inputStatus: boolean, delay: number) {
  const [rightTimeout, setRightTimeout] = useState<NodeJS.Timeout | null>(null);

  const [left, setLeft] = useState(false);
  const [right, setRight] = useState(inputStatus);

  function show() {
    setRight(true);

    clearScaffoldingTimeout();

    setTimeout(() => {
      setLeft(true);
    }, 0);
  }

  function hide() {
    setLeft(false);

    const timeoutId = setTimeout(() => {
      setRight(false);
    }, delay);

    setRightTimeout(timeoutId);
  }

  function clearScaffoldingTimeout() {
    if (rightTimeout) {
      clearTimeout(rightTimeout);
      setRightTimeout(null);
    }
  }

  useEffect(() => {
    inputStatus ? show() : hide();
  }, [inputStatus]);

  return {
    left,
    right,
  };
}

export default useDoubleSwitchDelay;
